import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { activateDropAreaOverlay } from "../../../use-cases/activate-drop-area-overlay";
import { setupDragImageOurNode } from "../../../use-cases/setup-drag-image-our-node";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";

export const handleDragStartOurNode = (e, type) => {
  const logger = getLogger();
  const t0 = performance.now();
  logger.debug("t0 - start of action", t0);

  const structureNodeset =
    type === "initial"
      ? getInitialStructureNodeset()
      : getMachineStructureNodeset();
  const selectedNodeIds = structureNodeset.selectedNodeIds;
  const amountOfSelectedNodes = selectedNodeIds.size;
  const firstSelectedElementId = selectedNodeIds.values().next().value;

  if (firstSelectedElementId) {
    const flatMap = structureNodeset.getFlatMap();
    const firstSelectedElement = flatMap.get(firstSelectedElementId);

    setupDragImageOurNode(e, firstSelectedElement, amountOfSelectedNodes, type);
    activateDropAreaOverlay();
    if (firstSelectedElement) {
      setupDragImageOurNode(
        e,
        firstSelectedElement,
        amountOfSelectedNodes,
        type,
      );
      activateDropAreaOverlay();

      const t1 = performance.now();
      logger.debug("t1 - end of action", t1);
      logger.debug(
        `Action to create drag cursor from ${
          type === "initial" ? "new initial structure" : "new machine structure"
        } took ${t1 - t0} milliseconds.`,
      );
    }
  }
};
